module.exports = __webpack_public_path__ + "img/LOGO_color_experts.941ac265.svg";